import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-objetivo-campanha-badges',
    templateUrl: './objetivo-campanha-badges.component.html',
    styleUrls: ['./objetivo-campanha-badges.component.less']
})
export class ObjetivoCampanhaBadgesComponent {
    @Input() objetivoVenda = false;
    @Input() objetivoBonificacao = false;
    @Input() objetivoAquisicao = false;

    @Input() title: string;
    @Input() fontSize = '12px';
}
